import {useCallback, useEffect, useMemo, useState} from "react";
import '@inovua/reactdatagrid-community/index.css'
import {useFormikContext} from "formik";
import {euroFormat} from "../../../utils/usefullFunctions";
import CustomDataGrid from "../../table/CustomDataGrid";

// Component which handles all the hours editing
const HoursTable = () => {
    const {values, setFieldValue} = useFormikContext();
    const {
        service_form_project_building_totals,
        service_form_project_hour_tariffs,
        service_form_project_data_hour,
        service_form_project_building,
        service_form_project_options
    } = values

    const columns =  useMemo(()=>[
        {
            name: 'name', header: 'Naam', minWidth: 300, editable: false,
            render: ({value,data}) => { // For the energie monitoring make the name disappear if off
                if (data.id === 4 && !service_form_project_options[8].value) return ""
                return value
            },
            onRender: (cellProps, {data}) => {  // For the energie monitoring make the cell dark if off
                if (data.id === 4 && !service_form_project_options[8].value) cellProps.style.background = '#f8f8f8'
            },
        },
        {
            name: 'hours', header: 'Uren', defaultFlex: 1, minWidth: 50, type: 'number',
            onRender: (cellProps, {data}) => {

                if (data.id < 3) cellProps.style.background = '#f8f8f8'
                if (data.id === 4 && !service_form_project_options[8].value) cellProps.style.background = '#f8f8f8'
            },
            render: ({value, data}) => {
                if (data.id === 4 && !service_form_project_options[8].value) return ""
                return value
            }
        },
        {
            name: 'corr', header: 'Correctie', defaultFlex: 1, minWidth: 50, type: 'number',
            onRender: (cellProps, {data}) => {
                if (data.id > 2) cellProps.style.background = '#f8f8f8'
            },
            render: ({value, data}) => {
                if (data.id === 4 && !service_form_project_options[8].value) return ""
                return value

            }
        },
        {
            name: 'cost', header: 'Kost', defaultFlex: 1, minWidth: 50, type: 'number', editable: false,
            render: ({value, data}) => {
                if (data.id === 4 && !service_form_project_options[8].value) return ""
                else if (value) return euroFormat(value)
            },
            onRender: (cellProps) => {
                cellProps.style.background = '#f8f8f8'

            }
        },
        {
            name: 'sale', header: 'Verkoop', defaultFlex: 1, minWidth: 50, type: 'number', editable: false,
            render: ({value, data}) => {
                if (data.id === 4 && !service_form_project_options[8].value) return ""
                else if (value) return euroFormat(value)
            },
            onRender: (cellProps) => {
                cellProps.style.background = '#f8f8f8'
            }
        },
        {
            name: 'comment', header: 'Toelichting', defaultFlex: 1, minWidth: 300,
            render: ({value, data}) => {
                if (data.id === 4 && !service_form_project_options[8].value) return ""
                return value
            },
            onRender: (cellProps) => {
                cellProps.style.background = '#f8f8f8'
            }
        },
    ],[service_form_project_options])

    // Datasource aanpassen wanneer de totalen van het gebouw veranderen of de uurtarieven
    useEffect(() => {
        if (service_form_project_hour_tariffs && service_form_project_building_totals) {
            const data = [...dataSource];
            const hours = {
                boa: service_form_project_building_totals.boa + dataSource[0]["corr"],
                ohddc: service_form_project_building_totals.ohddc + dataSource[1]["corr"],
                ohveld: service_form_project_building_totals.ohveld + dataSource[2]["corr"],
            }
            data[0]["hours"] = service_form_project_building_totals.boa;
            data[0]["cost"] = hours.boa * service_form_project_hour_tariffs.boa.cost;
            data[0]["sale"] = hours.boa * service_form_project_hour_tariffs.boa.cost / (1 - service_form_project_hour_tariffs.boa.margin);
            data[1]["hours"] = hours.ohddc;
            data[1]["cost"] = hours.ohddc * service_form_project_hour_tariffs.oh.cost;
            data[1]["sale"] = hours.ohddc * service_form_project_hour_tariffs.oh.cost / (1 - service_form_project_hour_tariffs.oh.margin);
            data[2]["hours"] = hours.ohveld;
            data[2]["cost"] = hours.ohveld * service_form_project_hour_tariffs.oh.cost;
            data[2]["sale"] = hours.ohveld * service_form_project_hour_tariffs.oh.cost / (1 - service_form_project_hour_tariffs.oh.margin);
            data[3]["cost"] = data[3]["hours"] * service_form_project_hour_tariffs.pl.cost;
            data[3]["sale"] = data[3]["hours"] * service_form_project_hour_tariffs.pl.cost / (1 - service_form_project_hour_tariffs.pl.margin);
            setDataSource(data);
        }
    }, [service_form_project_building_totals, service_form_project_hour_tariffs])

    const [dataSource, setDataSource] = useState(service_form_project_data_hour);

    // Sla de veranderingen op in de context
    useEffect(() => {
        setFieldValue("service_form_project_hours_cost", {
            boa: dataSource[0].cost,
            ohddc: dataSource[1].cost,
            ohveld: dataSource[2].cost,
            pl: dataSource[3].cost,
            energy: service_form_project_options[8].value ? dataSource[4].cost : 0,
            boaBasis: dataSource[5].cost,
        })

        setFieldValue("service_form_project_data_hour", dataSource)

    }, [dataSource, service_form_project_options])

    // When changes are made to the table adjust the data in the other columns
    const onEditComplete = useCallback(({value, columnId, rowId}) => {
        const data = [...dataSource];
        if (columnId === "hours") {
            if (rowId < 3) return null
            value = parseInt(value || 0)
            data[rowId][columnId] = value;
            data[rowId]["cost"] = value * service_form_project_hour_tariffs.boa.cost;
            data[rowId]["sale"] = value * service_form_project_hour_tariffs.boa.cost / (1 - service_form_project_hour_tariffs.boa.margin);
        } else if (columnId === "corr") {
            if (rowId > 2) return null
            value = parseInt(value || 0)
            if (rowId === 0) {
                data[rowId][columnId] = value;
                data[rowId]["cost"] = (value + data[rowId]["hours"]) * service_form_project_hour_tariffs.boa.cost;
                data[rowId]["sale"] = (value + data[rowId]["hours"]) * service_form_project_hour_tariffs.boa.cost / (1 - service_form_project_hour_tariffs.boa.margin);
            }
            data[rowId][columnId] = value;
            data[rowId]["cost"] = (value + data[rowId]["hours"]) * service_form_project_hour_tariffs.oh.cost;
            data[rowId]["sale"] = (value + data[rowId]["hours"]) * service_form_project_hour_tariffs.oh.cost / (1 - service_form_project_hour_tariffs.oh.margin);
        } else data[rowId][columnId] = value;
        setDataSource(data);
    }, [dataSource, service_form_project_hour_tariffs, service_form_project_building])


    return <CustomDataGrid
        onEditComplete={onEditComplete}
        editable={true}
        columns={columns}
        dataSource={dataSource}
    />
}


export default HoursTable